module.exports = __webpack_public_path__ + "807e62ccf31879eaed3ad2015ff21e56.png";